import API from '../';

export const authAPI = new API('/login');

export const logOutAPI = new API('/login/out');

export const validateToken = new API('/token/validaVencimientoToken');
export const renewToken = new API('/token/renuevaToken');
